import type {SVGProps} from 'react'
const DotsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 16"
    width="1em"
    height="1em"
    {...props}
  >
    <circle cx={3} cy={8} r={1.25} />
    <circle cx={8} cy={8} r={1.25} />
    <circle cx={13} cy={8} r={1.25} />
  </svg>
)
export {DotsIcon}
